/* eslint-disable @typescript-eslint/promise-function-async */
import { Routes } from '@angular/router';
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const EmailRoutes: Routes = [
  {
    path: RoutePaths.MODIFY_POLICY.POLICY_DATA.EMAIL.route,
    loadChildren: () => import('@pages/policy-data/email/email.module').then(m => m.EmailPageModule),
    canActivate: [NavigationGuard],
  },
];
